import { isServerside } from '../../../core/utils/isServerside';

import { getBuyingGuideStatus, getDealsPageStatus } from './keywords';

/**
 * Shared function to determine the Vanilla article type.
 * This doesn't read the HTML so that it can be used both client-side and server-side.
 */
export const getVanillaArticleType = ({
  payloadArticleType,
  keywords = [],
  urlPath = '',
}: {
  payloadArticleType?: string;
  keywords?: string[];
  urlPath?: string;
} = {}): string => {
  const articleType =
    payloadArticleType ??
    (!isServerside() ? (window.ffte?.properties?.articleType as string | undefined) : undefined);

  // article type, keywords (type from fep, keywords from dfp_config OR sent from client to SS)
  // Article type "buying-guide" is not supported for all sites, so support both - HAWK-657
  if (getBuyingGuideStatus(keywords) || articleType === 'buying-guide') {
    return 'buying_guide';
  }
  if (getDealsPageStatus(keywords)) {
    return 'deals';
  }
  if (/\/deals\/compare.*$/.exec(urlPath)) {
    return 'deals_compare';
  }

  switch (articleType) {
    case 'review':
    case 'award':
    case 'voucher':
    case 'category':
      return articleType;
    case 'best':
    case 'best-pick':
    case 'news':
    case 'feature': // feature can't be relied upon (could be a gallery, news, buying guide and possibly more) so we consider it to be news
      return 'news';
    default:
      return 'hub';
  }
};
